<cac-dialog-layout [title]="data.user ? 'Edit Customer' : 'Create new Customer'"
  subtitle="Enter the required data and save" [form]="form" (onSubmit)="onSubmit($event)">
  <cac-tabs>
    <cac-tab label="Customer Information">
      <div class="flex gap-6 mt-3">
        <div class="grid grid-cols-2 gap-x-6 gap-y-2 w-full">
          <cac-field [control]="form.controls.fullName" label="Full Name"></cac-field>

          <cac-field [control]="form.controls.email" label="Email"></cac-field>
          <div class="col-span-2 grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)] gap-3 items-start" dir="ltr">
            <lib-country-code-field [control]="form.controls.countryCode" />
            <cac-field [control]="form.controls.phoneNumber" label="Phone number" />
          </div>
        </div>
      </div>
      <div class="grid grid-cols-6 gap-x-6 gap-y-2 mt-5">
        <cac-field
          [control]="form.controls.status"
          label="Status"
          controlType="select"
          [searchable]="false"
          [clearable]="false"
          [items]="StatusValues"
          class="col-span-2"
        ></cac-field>
      </div>
    </cac-tab>
    <cac-tab *ngIf="data.user" label="Customer Addresses">
      <cac-table [options]="addressTable"></cac-table>
    </cac-tab>
    <cac-tab *ngIf="data.user" label="Customer Orders">
      <cac-table [options]="ordersTable"></cac-table>
    </cac-tab>
  </cac-tabs>
  <div class="flex gap-2 me-auto" slot="bottom">
    @if (data.user) {
      <cac-button *ngIf="!isRestrictedAdmin" (onClick)="addVendorRole($event)" appearance="stroked">Become Vendor</cac-button>
      <cac-button (onClick)="onForceLogout($event)" appearance="stroked">Force Login</cac-button>
      <cac-button (onClick)="onWalletTransaction($event)" appearance="stroked">Wallet Transaction</cac-button>
      <cac-button *ngIf="!isRestrictedAdmin" (onClick)="onDelete($event)" theme="error">Delete user</cac-button>
    }
  </div>
</cac-dialog-layout>
